;(function() {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;

  // CSS変数から in/out の継続時間をミリ秒で取得
  const parseCssDurationMs = (raw, fallbackMs) => {
    if (!raw || typeof raw !== 'string') return fallbackMs;
    const v = raw.trim();
    if (v.endsWith('ms')) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallbackMs;
    }
    if (v.endsWith('s')) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? Math.round(n * 1000) : fallbackMs;
    }
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallbackMs;
  };

  const rootStyle = getComputedStyle(document.documentElement);
  const transitionDurationIn = parseCssDurationMs(rootStyle.getPropertyValue('--preloader-duration-in'), 1300);
  const transitionDurationOut = parseCssDurationMs(rootStyle.getPropertyValue('--preloader-duration-out'), 1200);
  const easingVar = (rootStyle.getPropertyValue('--preloader-easing') || 'cubic-bezier(0.7, 0, 0.3, 1)').trim();

  // 内部遷移フラグ（出発→到着を滑らかに繋ぐため）
  const NEXT_FLAG_KEY = 'ag-preloader-next';
  const hasNextFlag = () => sessionStorage.getItem(NEXT_FLAG_KEY) === '1';
  const setNextFlag = () => { try { sessionStorage.setItem(NEXT_FLAG_KEY, '1'); } catch (e) {} };
  const clearNextFlag = () => { try { sessionStorage.removeItem(NEXT_FLAG_KEY); } catch (e) {} };

  // セクション設定: data-show-once（セッション内で到着側の表示を1回に制限）
  // 連続体験重視のため、2回目以降も到着側アニメを出したい場合は isShowOnce を false に扱う
  const SHOW_ONCE_KEY = 'ag-preloader-once';
  const isShowOnceRaw = preloader.getAttribute('data-show-once') === 'true';
  const isShowOnce = false && isShowOnceRaw; // 常時シームレス優先（必要なら true に戻す）
  const hasShownOnce = () => sessionStorage.getItem(SHOW_ONCE_KEY) === '1';
  const setShownOnce = () => { try { sessionStorage.setItem(SHOW_ONCE_KEY, '1'); } catch (e) {} };

  const showEntering = (addEntering = true) => {
    preloader.style.display = 'flex';
    preloader.classList.remove('is-hidden', 'is-exiting', 'is-entering');
    // レイアウト確定
    void preloader.offsetWidth;
    if (addEntering) {
      preloader.classList.add('is-entering');
    }
  };

  const startExit = () => {
    preloader.classList.remove('is-entering');
    // reflow を入れてから is-exiting を付与して確実にトランジションを発火
    void preloader.offsetWidth;
    preloader.classList.add('is-exiting');
    setTimeout(() => {
      preloader.classList.add('is-hidden');
      preloader.style.display = 'none';
      preloader.classList.remove('is-entering', 'is-exiting');
    }, transitionDurationOut);
  };

  // 到着側：内部遷移時のみ短く表示→退場（外部流入・リロードでは表示しない）
  window.addEventListener('DOMContentLoaded', () => {
    if (hasNextFlag() && !(isShowOnce && hasShownOnce())) {
      clearNextFlag();
      // 到着時は全面カバー状態から直接退場アニメへ（entering は付与しない）
      showEntering(false);
      setTimeout(startExit, Math.max(200, Math.min(400, transitionDurationIn * 0.25)));
      if (isShowOnce) setShownOnce();
    } else {
      preloader.classList.add('is-hidden');
      preloader.style.display = 'none';
    }
  });

  // 出発側：内部リンククリック時に表示→既定時間後に遷移
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    // カートドロアーを開くトリガーの場合はプリローダーを発動しない
    if (
      link.id === 'cart-icon' ||
      link.classList.contains('js-open-cart-drawer')
    ) {
      return;
    }

    const href = link.getAttribute('href');
    const isBlank = link.target === '_blank';
    const isAnchor = href && href.startsWith('#');
    const isProtocol = href && (href.startsWith('mailto:') || href.startsWith('tel:'));
    const isDownload = link.hasAttribute('download');
    const isExternal = link.hostname !== window.location.hostname;

    if (!href || href === '' || isBlank || isAnchor || isProtocol || isDownload || isExternal) {
      return;
    }

    event.preventDefault();

    setNextFlag();

    // 出発時: インラインで確実にトランジションを発火
    preloader.style.display = 'flex';
    preloader.classList.remove('is-hidden', 'is-exiting', 'is-entering');
    preloader.style.transition = 'none';
    preloader.style.clipPath = 'circle(0% at 0% 50%)';
    // reflow
    void preloader.offsetWidth;
    // 1フレーム後にトランジションを適用
    requestAnimationFrame(() => {
      preloader.style.transition = `clip-path ${transitionDurationIn}ms ${easingVar}`;
      // 次フレームで目標値へ
      requestAnimationFrame(() => {
        preloader.style.clipPath = 'circle(150% at 0% 50%)';
      });
    });

    setTimeout(() => { window.location.href = href; }, transitionDurationIn);
  });

  // 3. ブラウザの「戻る/進む」ボタンの処理 (bfcache対策)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      preloader.style.transition = 'none';
      preloader.classList.remove('is-entering', 'is-exiting', 'is-hidden');
      preloader.style.display = 'none';
      requestAnimationFrame(() => {
        preloader.style.transition = '';
      });
    }
  });

})();